import { Email, ID, MemberType } from "@nova/constants"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { OrganizationPermissions } from "@nova/schemas"

async function listMembersForWorkspace(workspaceId: ID) {
    const { users } = await fetchApiGateway("get /org/:orgId/users", {
        params: { orgId: workspaceId },
        query: "includeInvites=true",
    })
    return users
}

async function createAllInvites(
    workspaceId: ID,
    userIds: Email[],
    permissions: OrganizationPermissions
) {
    const { members } = await fetchApiGateway("post /org/:orgId/invites", {
        params: { orgId: workspaceId },
        body: { userIds, permissions },
    })
    return members
}

async function updateMember(
    workspaceId: ID,
    userId: ID,
    attributes: {
        type?: MemberType
        userSettings?: { name: string; value: string | boolean }[]
        permissions?: OrganizationPermissions
        favorites?: string[]
        recentId?: string
        recentSearch?: { pluginName: string; data: unknown }
    }
) {
    const { member } = await fetchApiGateway("patch /org/:orgId/member/:userId", {
        params: { orgId: workspaceId, userId },
        body: { attributes },
    })
    return member
}

async function updateMemberAccessRequest(
    userId: ID,
    accessRequestId: ID,
    workspaceId?: ID,
    _projectId?: ID,
    removeRequest?: boolean
) {
    if (!workspaceId) throw new Error("workspaceId is required for updateMemberAccessRequest")
    const { member } = await fetchApiGateway("patch /org/:orgId/member/:userId/access-request", {
        params: { orgId: workspaceId, userId },
        body: { accessRequestId, removeRequest },
    })
    return member
}

async function softDeleteMember(workspaceId: ID, userId: ID) {
    await fetchApiGateway("delete /org/:orgId/member/:userId", {
        params: { orgId: workspaceId, userId },
    })
    return true
}

async function acceptMemberInvitations(email: Email) {
    await fetchApiGateway("post /me/accept-invitations", {
        body: { email },
    })
    return true
}

export const membersApi = {
    listMembersForWorkspace,
    createAllInvites,
    updateMember,
    softDeleteMember,
    acceptMemberInvitations,
    updateMemberAccessRequest,
}
